import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { QueryParamsHandling } from '@angular/router';

@Component({
  selector: 'app-route-link',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './route-link.component.html',
  styleUrls: ['./route-link.component.less']
})
export class RouteLinkComponent {

  @Input() route?: any;
  @Input() queryParams$?: any = {};
  @Input() queryParamsHandling?: QueryParamsHandling | null | undefined = null;

  constructor() {}
}
